import React from 'react';
import { Container, Image, Title, Description } from './styles';

interface Props {
  image: string;
  title: string;
  description: string;
}

const Scholarship: React.FC<Props> = ({ image, title, description }) => {
  return (
    <Container>
      <Image src={image} />
      <div style={{ height: '24px' }} />
      <Title>{title}</Title>
      <div style={{ height: '24px' }} />
      <Description>{description}</Description>
    </Container>
  );
};

export { Scholarship };
